import { Circle, CustomQuestion } from "./style";

export function Question() {
  return (
    <Circle>
      <CustomQuestion />
    </Circle>
  );
}
